// extracted by mini-css-extract-plugin
module.exports = {"name":"_1IfuHN8kkmV5g5ukwt7H5i","btn":"_2qtmzPLZJ8hDDPGYrtCoxK"};